import script from "./AttachmentsList.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentsList.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentsList.vue?vue&type=style&index=0&id=28896ed4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28896ed4"]])

export default __exports__